// https://docs.google.com/spreadsheets/d/1IYxMi9virNYdQJeNgDbp6f_HRXk62Ql72P2LL6wpKaU/edit?ts=5ef41275#gid=0
import { LOCATIONS } from 'components/tracking';

// #9
export function incentivisedLoginCampaignPageLoadEvent (track) {
  track({ data: { location: LOCATIONS.CAMPAIGN_PAGE } });
}

// #10
export function incentivisedLoginTopSignupBtnClickEvent (track) {
  const trackingData = {
    event: 'signupNow',
    location: LOCATIONS.CAMPAIGN_PAGE,
    componentType: 'button',
    position: 1,
  };

  track({ data: trackingData });
}

export function incentivisedLoginTopSigninLinkClickEvent (track) {
  const trackingData = {
    event: 'signupNow',
    location: LOCATIONS.CAMPAIGN_PAGE,
    componentType: 'text',
    position: 1.5,
  };

  track({ data: trackingData });
}

// #11
export function incentivisedLoginSignupLoginTextClickEvent ({ track, componentType }) {
  const trackingData = {
    event: 'signupNow',
    location: LOCATIONS.CAMPAIGN_PAGE,
    componentType,
    position: 2,
  };

  track({ data: trackingData });
}

// #12
export function incentivisedLoginFooterSignupBtnClickEvent (track) {
  const trackingData = {
    event: 'signupNow',
    location: LOCATIONS.CAMPAIGN_PAGE,
    componentType: 'button',
    position: 3,
  };

  track({ data: trackingData });
}

export function incentivisedLoginSignupBannerClickEvent (track) {
  const trackingData = {
    event: 'signupNow',
    location: LOCATIONS.CAMPAIGN_PAGE,
    componentType: 'bottom-sticky',
    position: 100,
  };

  track({ data: trackingData });
}

export default {};
